// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-waivers-workItems-work-item-details-module__wrapper--r5y5t {
  background: #071c35;
  padding: 0 10px;
  color: white;
}

.src-js-waivers-workItems-work-item-details-module__title--b1gbP {
  background: #b9bfc6;
  font-weight: bold;
  text-align: center;
  padding: 10px;
}

.src-js-waivers-workItems-work-item-details-module__content--AHwrD {
  background: #7a8794;
  padding: 10px;
}

.src-js-waivers-workItems-work-item-details-module__workItemDataFields--kT2fi {
  padding: 5px 0;
}

.src-js-waivers-workItems-work-item-details-module__workItemDataFieldLabel--l7DFc {
  font-weight: bold;
  padding-right: 15px;
  text-align: right;
}

.src-js-waivers-workItems-work-item-details-module__workItemDataFieldValue--aobpS {
}

.src-js-waivers-workItems-work-item-details-module__workItemDataLink--kE26n {
  display: inline-block;
}

.src-js-waivers-workItems-work-item-details-module__emailContent--xIZtf {
  background: white;
  color: black;
  padding: 10px;
  margin-top: 15px;
}

.src-js-waivers-workItems-work-item-details-module__emailBodyEmbed--u97rT {
  width: 100%;
  overflow-x: scroll;
}

.src-js-waivers-workItems-work-item-details-module__emailFromAddress--l77Yv {
  font-size: 14px;
  padding: 3px 0 15px 5px;
}

.src-js-waivers-workItems-work-item-details-module__emailSubjectLine--uF_1D {
  font-size: 16px;
  font-weight: bold;
  padding: 5px 5px;
}

.src-js-waivers-workItems-work-item-details-module__websiteChange--uR6UR {
  margin: 20px 0;
  background-color: #b9bfc6;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangesetTitleText--ym4jU {
  display: inline-block;
  font-weight: bold;
  margin-right: 10px;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeTitle--txLoy {
  padding: 10px;
  text-align: center;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeTitleText--ZC6yb {
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeContent--OZN7s {
  padding: 10px;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeLink--lXUWG {
  color: white !important;
  text-decoration: underline;
  font-weight: 300 !important;
  display: inline-block;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeLink--lXUWG:hover {
  color: #eee !important;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeImage--bBADV {
  padding: 3px;
}

.src-js-waivers-workItems-work-item-details-module__websiteChangeControls--feBv7 {
  padding: 10px;
}

.src-js-waivers-workItems-work-item-details-module__workItemLink--cHOn3 {
  font-weight: 400;
}

.src-js-waivers-workItems-work-item-details-module__workItemInput--TcJZm select {
  background-color: #b9bfc6 !important;
  color: white !important;
  border: 1px solid white !important;
}

.src-js-waivers-workItems-work-item-details-module__workItemInput--TcJZm textarea::placeholder {
  color: #ddd;
}

.src-js-waivers-workItems-work-item-details-module__actionPicker--GC6up {
  margin-top: 10px;
}

.src-js-waivers-workItems-work-item-details-module__spinnerWrap--cfGzA {
  margin: 0 5px;
}

.src-js-waivers-workItems-work-item-details-module__updateMessage--rhbQY {
  padding: 5px 10px;
  border-radius: 4px;
}

.src-js-waivers-workItems-work-item-details-module__modalTextKey--RIJGS {
  text-align: right;
}

.src-js-waivers-workItems-work-item-details-module__modalTextValue--qV5yG {
  font-weight: bold;
}

.src-js-waivers-workItems-work-item-details-module__modalInputRow--oLW9k {
  margin-top: 10px;
}

.src-js-waivers-workItems-work-item-details-module__airlineSnoozeIcon--_siUR {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  cursor: pointer;
}

.src-js-waivers-workItems-work-item-details-module__airlineSnoozeModalContent--uohUf {
  margin-top: 10px;
}

.src-js-waivers-workItems-work-item-details-module__airlineSnoozeModalLabel--Hfm7M {
  text-align: right;
  padding-top: 3px;
}

.src-js-waivers-workItems-work-item-details-module__attachmentMessage--MYLSH {
  font-style: italic;
}

.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT {
  padding: 15px;
  border: 1px solid;
  border-radius: 6px;
  margin: 10px 10px 10px 0;
  display: inline-block;
  text-decoration: none;
}

.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT:hover {
  background-color: #eee;
}

.src-js-waivers-workItems-work-item-details-module__attachmentLink--h8tkH {
  display: block;
  margin: auto;
}

.src-js-waivers-workItems-work-item-details-module__attachmentIcon--atq7N {
  font-size: 1.4em;
  display: block;
  margin: auto;
  text-align: center;
  padding: 5px;
}

.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT a,
a:hover.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT,
a:visited.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT,
a:active.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT,
a:focus.src-js-waivers-workItems-work-item-details-module__attachment--XGsbT {
  text-decoration: none;
}

.src-js-waivers-workItems-work-item-details-module__attachmentSeparator--v9cXY {
  margin: 10px 0;
  border: 0;
  border-bottom: 1px dotted #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/js/waivers/workItems/work-item-details.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;AACA;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8BAA8B;AAChC","sourcesContent":[".wrapper {\n  background: #071c35;\n  padding: 0 10px;\n  color: white;\n}\n\n.title {\n  background: #b9bfc6;\n  font-weight: bold;\n  text-align: center;\n  padding: 10px;\n}\n\n.content {\n  background: #7a8794;\n  padding: 10px;\n}\n\n.workItemDataFields {\n  padding: 5px 0;\n}\n\n.workItemDataFieldLabel {\n  font-weight: bold;\n  padding-right: 15px;\n  text-align: right;\n}\n\n.workItemDataFieldValue {\n}\n\n.workItemDataLink {\n  display: inline-block;\n}\n\n.emailContent {\n  background: white;\n  color: black;\n  padding: 10px;\n  margin-top: 15px;\n}\n\n.emailBodyEmbed {\n  width: 100%;\n  overflow-x: scroll;\n}\n\n.emailFromAddress {\n  font-size: 14px;\n  padding: 3px 0 15px 5px;\n}\n\n.emailSubjectLine {\n  font-size: 16px;\n  font-weight: bold;\n  padding: 5px 5px;\n}\n\n.websiteChange {\n  margin: 20px 0;\n  background-color: #b9bfc6;\n}\n\n.websiteChangesetTitleText {\n  display: inline-block;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.websiteChangeTitle {\n  padding: 10px;\n  text-align: center;\n}\n\n.websiteChangeTitleText {\n  display: inline-block;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.websiteChangeContent {\n  padding: 10px;\n}\n\n.websiteChangeLink {\n  color: white !important;\n  text-decoration: underline;\n  font-weight: 300 !important;\n  display: inline-block;\n}\n\n.websiteChangeLink:hover {\n  color: #eee !important;\n}\n\n.websiteChangeImage {\n  padding: 3px;\n}\n\n.websiteChangeControls {\n  padding: 10px;\n}\n\n.workItemLink {\n  font-weight: 400;\n}\n\n.workItemInput select {\n  background-color: #b9bfc6 !important;\n  color: white !important;\n  border: 1px solid white !important;\n}\n\n.workItemInput textarea::placeholder {\n  color: #ddd;\n}\n\n.actionPicker {\n  margin-top: 10px;\n}\n\n.spinnerWrap {\n  margin: 0 5px;\n}\n\n.updateMessage {\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.modalTextKey {\n  text-align: right;\n}\n\n.modalTextValue {\n  font-weight: bold;\n}\n\n.modalInputRow {\n  margin-top: 10px;\n}\n\n.airlineSnoozeIcon {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.airlineSnoozeModalContent {\n  margin-top: 10px;\n}\n\n.airlineSnoozeModalLabel {\n  text-align: right;\n  padding-top: 3px;\n}\n\n.attachmentMessage {\n  font-style: italic;\n}\n\n.attachment {\n  padding: 15px;\n  border: 1px solid;\n  border-radius: 6px;\n  margin: 10px 10px 10px 0;\n  display: inline-block;\n  text-decoration: none;\n}\n\n.attachment:hover {\n  background-color: #eee;\n}\n\n.attachmentLink {\n  display: block;\n  margin: auto;\n}\n\n.attachmentIcon {\n  font-size: 1.4em;\n  display: block;\n  margin: auto;\n  text-align: center;\n  padding: 5px;\n}\n\n.attachment a,\na:hover.attachment,\na:visited.attachment,\na:active.attachment,\na:focus.attachment {\n  text-decoration: none;\n}\n\n.attachmentSeparator {\n  margin: 10px 0;\n  border: 0;\n  border-bottom: 1px dotted #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `src-js-waivers-workItems-work-item-details-module__wrapper--r5y5t`,
	"title": `src-js-waivers-workItems-work-item-details-module__title--b1gbP`,
	"content": `src-js-waivers-workItems-work-item-details-module__content--AHwrD`,
	"workItemDataFields": `src-js-waivers-workItems-work-item-details-module__workItemDataFields--kT2fi`,
	"workItemDataFieldLabel": `src-js-waivers-workItems-work-item-details-module__workItemDataFieldLabel--l7DFc`,
	"workItemDataFieldValue": `src-js-waivers-workItems-work-item-details-module__workItemDataFieldValue--aobpS`,
	"workItemDataLink": `src-js-waivers-workItems-work-item-details-module__workItemDataLink--kE26n`,
	"emailContent": `src-js-waivers-workItems-work-item-details-module__emailContent--xIZtf`,
	"emailBodyEmbed": `src-js-waivers-workItems-work-item-details-module__emailBodyEmbed--u97rT`,
	"emailFromAddress": `src-js-waivers-workItems-work-item-details-module__emailFromAddress--l77Yv`,
	"emailSubjectLine": `src-js-waivers-workItems-work-item-details-module__emailSubjectLine--uF_1D`,
	"websiteChange": `src-js-waivers-workItems-work-item-details-module__websiteChange--uR6UR`,
	"websiteChangesetTitleText": `src-js-waivers-workItems-work-item-details-module__websiteChangesetTitleText--ym4jU`,
	"websiteChangeTitle": `src-js-waivers-workItems-work-item-details-module__websiteChangeTitle--txLoy`,
	"websiteChangeTitleText": `src-js-waivers-workItems-work-item-details-module__websiteChangeTitleText--ZC6yb`,
	"websiteChangeContent": `src-js-waivers-workItems-work-item-details-module__websiteChangeContent--OZN7s`,
	"websiteChangeLink": `src-js-waivers-workItems-work-item-details-module__websiteChangeLink--lXUWG`,
	"websiteChangeImage": `src-js-waivers-workItems-work-item-details-module__websiteChangeImage--bBADV`,
	"websiteChangeControls": `src-js-waivers-workItems-work-item-details-module__websiteChangeControls--feBv7`,
	"workItemLink": `src-js-waivers-workItems-work-item-details-module__workItemLink--cHOn3`,
	"workItemInput": `src-js-waivers-workItems-work-item-details-module__workItemInput--TcJZm`,
	"actionPicker": `src-js-waivers-workItems-work-item-details-module__actionPicker--GC6up`,
	"spinnerWrap": `src-js-waivers-workItems-work-item-details-module__spinnerWrap--cfGzA`,
	"updateMessage": `src-js-waivers-workItems-work-item-details-module__updateMessage--rhbQY`,
	"modalTextKey": `src-js-waivers-workItems-work-item-details-module__modalTextKey--RIJGS`,
	"modalTextValue": `src-js-waivers-workItems-work-item-details-module__modalTextValue--qV5yG`,
	"modalInputRow": `src-js-waivers-workItems-work-item-details-module__modalInputRow--oLW9k`,
	"airlineSnoozeIcon": `src-js-waivers-workItems-work-item-details-module__airlineSnoozeIcon--_siUR`,
	"airlineSnoozeModalContent": `src-js-waivers-workItems-work-item-details-module__airlineSnoozeModalContent--uohUf`,
	"airlineSnoozeModalLabel": `src-js-waivers-workItems-work-item-details-module__airlineSnoozeModalLabel--Hfm7M`,
	"attachmentMessage": `src-js-waivers-workItems-work-item-details-module__attachmentMessage--MYLSH`,
	"attachment": `src-js-waivers-workItems-work-item-details-module__attachment--XGsbT`,
	"attachmentLink": `src-js-waivers-workItems-work-item-details-module__attachmentLink--h8tkH`,
	"attachmentIcon": `src-js-waivers-workItems-work-item-details-module__attachmentIcon--atq7N`,
	"attachmentSeparator": `src-js-waivers-workItems-work-item-details-module__attachmentSeparator--v9cXY`
};
export default ___CSS_LOADER_EXPORT___;
